const HOMEPROT = () => import('./../views/Home.vue')
const PROC = () => import('./../views/Protocolo.vue')

export default [
  { name: 'viewProtocolo', path: '/protocolo', component: HOMEPROT, meta: { acl: true } },
  { name: 'viewProcessos', path: '/protocolo/processo', component: PROC, meta: { acl: true } }
]
